import { PaymentStatus } from "@gigsync/protocol";
const S = PaymentStatus.enum;
/** A payment is a receipt once the owner said they paid it; requested or disputed ones are not. */
const PAID = new Set([S.paid, S.confirmed]);
const paidAt = (p) => new Date(p.confirmed_at ?? p.paid_at ?? p.requested_at ?? 0);
/**
 * What the owner paid, newest first: every payment from `me` that they said they paid or the worker confirmed, with
 * its job. A payment whose job is not on this phone is left out: there is nothing to show it with.
 */
export function receiptsOf(jobs, payments, me) {
    const byId = new Map(jobs.map((j) => [j.engagement.id, j]));
    const out = [];
    for (const payment of payments) {
        const job = byId.get(payment.engagement);
        if (!job || payment.payer !== me || !PAID.has(payment.status))
            continue;
        out.push({ job, payment, confirmed: payment.status === S.confirmed, at: paidAt(payment) });
    }
    return out.sort((a, b) => b.at.getTime() - a.at.getTime() || b.payment.id.localeCompare(a.payment.id));
}
//# sourceMappingURL=receipts.js.map